import { z } from 'zod';

export const SettingSchema = z.object({
  language: z.string().optional(),
  currency: z.string().optional(),
});

export type SettingDetail = z.infer<typeof SettingSchema>;
